/**
 * `PLAN_GATED` — a refusal that names the tier which lifts it.
 *
 * The wire plan §2 U63 specifies, landed at U62 because U62 is the first gated act. A
 * refusal that only said *"not on your plan"* would make the screen guess which plan, and
 * `plans.ts` is the one place a tier's name and price are written.
 *
 * Built the {@link GateRefusalBody} way (`gate.ts`): `problem()` supplies `status`, `title`
 * and `type` from the registry, so a plan gate and an ordinary refusal for this code agree
 * in every member they share.
 */
import { problem } from "./problem.js";
export function planGate(plan, detail) {
    return { ...problem("PLAN_GATED", detail), code: "PLAN_GATED", plan };
}
/** Does this body name a tier the UI can render a gate for? */
export function isPlanGate(body) {
    return body.code === "PLAN_GATED" && typeof body.plan === "string";
}
//# sourceMappingURL=plan-gate.js.map